// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"825":"tws-breadcrumb-container","903":"tws-pebble-background-container"}[chunkId] + "." + {"825":"d35051e4c85ed04f","903":"d2958bc4948f7336"}[chunkId] + ".js";
};